import { Text, Image } from '@belong/ui';
import clsx from 'clsx';
import css from './comparison-table.module.css';
import { COMPARISON_TABLE_STRINGS } from './comparison-table.strings';
import { TableHeader } from './components/table-header';
import { TableRow } from './components/table-row';
import {
  LISTING_LEASING,
  ONOGING_PROPERTY_MANAGEMENT,
  CASHFLOW_FINANCIAL_TOOLS,
} from './constants';

// MOVE!
export const ComparisonTable = () => {
  return (
    <div className="flex flex-col items-center text-center">
      <Text variant="h2" fontWeight="semibold">
        {COMPARISON_TABLE_STRINGS['page.title1']}
      </Text>
      <Text variant="h3">{COMPARISON_TABLE_STRINGS['page.subtitle']}</Text>

      <div className="mt-xs border-green hidden w-1/6 border-b-4 border-solid lg:block"></div>

      <table className="mt-xl border-collapse">
        <thead>
          <tr className="border-gray w-full border border-solid">
            <th className="border-gray border border-solid" />
            <th className="border-gray bg-navy-translucent-light p-xs lg:p-sm border border-solid">
              <div className={clsx(css.logoContaniner)}>
                <Image src="/belong-x/logo_belong_pro_vertical.png" alt="" />
              </div>
            </th>
            <th className="border-gray p-xs lg:p-sm border border-solid text-center">
              <Text variant="p2" fontWeight="semibold" className="lg:h3 w-min">
                {COMPARISON_TABLE_STRINGS['table.header1']}
              </Text>
            </th>
            <th className="p-xs lg:p-sm text-center ">
              <Text variant="p2" fontWeight="semibold" className="lg:h3 w-min">
                {COMPARISON_TABLE_STRINGS['table.header2']}
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          <TableHeader title={LISTING_LEASING.title} />
          {LISTING_LEASING.content.map((row, index) => (
            <TableRow key={`${LISTING_LEASING.id}${index}`} {...row} />
          ))}
          <TableHeader title={ONOGING_PROPERTY_MANAGEMENT.title} />
          {ONOGING_PROPERTY_MANAGEMENT.content.map((row, index) => (
            <TableRow
              key={`${ONOGING_PROPERTY_MANAGEMENT.id}${index}`}
              {...row}
            />
          ))}
          <TableHeader title={CASHFLOW_FINANCIAL_TOOLS.title} />
          {CASHFLOW_FINANCIAL_TOOLS.content.map((row, index) => (
            <TableRow key={`${CASHFLOW_FINANCIAL_TOOLS.id}${index}`} {...row} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
